import axios from 'axios';
import { setupAxiosInterceptor } from './auth/axiosConfig';
import config from './config';

const skillsApi = axios.create({
  baseURL: config.API_BASE_URL + '/cellcog',
});
setupAxiosInterceptor(skillsApi);

export const listSkills = () =>
  skillsApi.get('/skills');

export const getSkill = (slug) =>
  skillsApi.get(`/skills/${encodeURIComponent(slug)}`);

export default skillsApi;
